export default __webpack_public_path__ + "static/reusable-components-1e0eb38522ec38346f91b5a22acf3f22.mp4";